type LoadingStateProps = {
  label: string;
  detail?: string;
  compact?: boolean;
  className?: string;
};

export function LoadingState({
  label,
  detail = "正在准备最新数据与页面视图",
  compact = false,
  className = "",
}: LoadingStateProps) {
  return <div
    className={`qy-loading-state${compact ? " is-compact" : ""}${className ? ` ${className}` : ""}`}
    aria-busy="true"
    aria-live="polite"
    aria-label={`正在加载${label}`}
  >
    <div className="qy-loading-orbit" aria-hidden="true">
      <i className="qy-loading-orbit-ring is-outer"><b /></i>
      <i className="qy-loading-orbit-ring is-inner"><b /></i>
      <span className="qy-loading-core" />
    </div>
    <div className="qy-loading-copy">
      <strong>{`正在加载${label}`}</strong>
      <span>{detail}</span>
    </div>
    {!compact ? <div className="qy-loading-skeleton" aria-hidden="true">
      <i className="is-wide" />
      <i />
      <i />
    </div> : null}
  </div>;
}
